import { defineStore } from 'pinia'

const useSelectedItemStore = defineStore('selectedItem', {
  state(){return{
    selectedItems: []
  }},
  getters: {
    getAllSelectedItems: (state) => state.selectedItems
  },
  actions: {
    addSelectedItems(item) {
      this.selectedItems.push(item)
    },
    deleteSelectedItems(indexToRemove) {
      this.selectedItems.splice(indexToRemove, 1);
    }
  }
})
export {useSelectedItemStore}